<template>
  <div id="alert-message-block"  :class="[modalMode ? 'message-modal' : 'message-main-screen']">
    <div :class="[successMessageArray.length > 0 ? 'success-msg-container' : hiddenSuccessMsgClass]" :style="`--messageHeight: ${heightMessageBox}px`">
      <transition-group name="slide">
        <div class="success-msg-box" v-for="msg in successMessageArray" :key="msg">
          <b-alert
            :show="dismissCountDown"
            @dismissed="dismissed(msg)"
            @dismiss-count-down="countDownChanged"
            variant="success"
            fade
          >
            <i class="material-icons check-circle">check_circle</i>
            <span v-html="msg" class="text-error-message"></span>
          </b-alert>
        </div>
      </transition-group>
    </div>
    <div :class="[errorMessageArray.length > 0 ? 'error-msg-container' : hiddenErrorMsgClass]" :style="`--messageHeight: ${heightMessageBox}px`">
      <transition-group name="slide">
        <div class="error-msg-box" v-for="msg in errorMessageArray" :key="msg">
          <b-alert
            show
            variant="danger"
            fade
          >
            <i class="material-icons report">report</i>
            <span v-html="msg" class="text-error-message" id="id-error-message"></span>
            <span v-if="importMode">
              <span @click="handleShowErrorMsgDetailButton" class="w-auto btn-detail">詳細</span>をご確認ください。
            </span>
            <span v-else-if="showErrorMsgDetailButton" @click="handleShowErrorMsgDetailButton" class="btn-detail">詳細</span>
            <i
              class="material-icons close-message ml-auto cursor-pointer"
              @click="handleCloseErrorMessage(msg)"
              v-if="closeIconErrMsg"
            >
              close
            </i>
          </b-alert>
        </div>
      </transition-group>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import FlashMessage from '../../common/flash-message.component'
import AppConstants from '../../constants/app.constants'
export default {
  data() {
    return {
      dismissSecs: 5,
      dismissCountDown: 0,
      hiddenSuccessMsgClass: '',
      hiddenErrorMsgClass: '',
      showErrorMsgDetailButton: false, // 詳細表示ボタンの条件
      heightMessageBox: 0
    }
  },
  computed: {
    ...mapGetters('flashMessage', ['errorMessageArray', 'successMessageArray']),
    ...mapGetters('settingWizardStore', ['getMenuStatus']),
    importMode() {
      return this.$store.getters.getImportMode
    },
    closeIconErrMsg() {
      return this.$store.getters.getCloseIconErrMsgMode
    },
    modalMode() {
      return this.$store.getters.getModalMode
    }
  },
  mounted() {
    this.hiddenSuccessMsgClass = ''
    this.hiddenErrorMsgClass = ''
  },
  methods: {
    /**
     * エラーメッセージの詳細ボタンを表示
     */
    handleShowErrorMsgDetailButton() {
      const idModalShow = this.showErrorMsgDetailButton ? AppConstants.ID_MODAL_ERROR_MESSAGE_DETAIL : AppConstants.ID_MODAL_ERROR_MESSAGE_IMPORT
      this.$bvModal.show(idModalShow)
    },
    ...mapActions('flashMessage', ['removeMessageFromErrorList', 'removeMessageFromSuccessList']),
    /**
     * エラーメッセージを閉じる
     * @param {string} msg エラーメッセージ
     */
    handleCloseErrorMessage(msg) {
      this.hiddenErrorMsgClass = 'animated-error-msg-container'
      this.removeMessageFromErrorList(msg)
      this.$store.commit('setImportMode', false)
      this.showErrorMsgDetailButton = false
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    dismissed(msg) {
      this.dismissCountDown = 0
      this.removeMessageFromSuccessList(msg)
    },
    /**
     * メッセージの高さを取得
     *
     * @param    msg      メッセージ
     * @returns {number}  メッセージの高さ
     */
    getHeightOfMessage(str) {
      return FlashMessage.getInstance().getHeightOfMessage(str)
    },
    /**
     * ウィンドウのサイズ変更
     */
    resizeWindow() {
      this.heightMessageBox = this.getHeightOfMessage(this.errorMessageArray[0])
      this.checkShowDetailButton()
    },
    /**
     * 詳細ボタンをチェックして表示
     */
    checkShowDetailButton() {
      const elementMessage = document.getElementById('id-error-message')
      if (elementMessage && (elementMessage.clientHeight < elementMessage.scrollHeight)) {
        this.showErrorMsgDetailButton = true
      } else {
        this.showErrorMsgDetailButton = false
      }
    }
  },
  watch: {
    successMessageArray() {
      this.dismissCountDown = this.dismissSecs
      if (this.successMessageArray.length > 0) {
        this.heightMessageBox = this.getHeightOfMessage(this.successMessageArray[0])
        // エラー メッセージのアニメーションを非表示にする CSS クラスを追加します。
        this.hiddenSuccessMsgClass = 'animated-success-msg-container'
        this.$store.commit('setImportMode', false)
      }
    },
    errorMessageArray() {
      this.showErrorMsgDetailButton = false
      if (this.errorMessageArray.length > 0) {
        this.heightMessageBox = this.getHeightOfMessage(this.errorMessageArray[0])
        FlashMessage.getInstance().hideAllSuccessMessages()
        window.addEventListener('resize', this.resizeWindow)
        // エラー メッセージのアニメーションを非表示にする CSS クラスを追加します。
        this.hiddenErrorMsgClass = 'animated-error-msg-container'
        // レンダリングされたメッセージの遅延
        setTimeout(() => {
          this.checkShowDetailButton()
        }, 330)
      } else {
        window.removeEventListener('resize', this.resizeWindow)
      }
      if (this.importMode && this.errorMessageArray.length > 0 && navigator.onLine) {
        this.$root.$emit('bv::show::modal', AppConstants.ID_MODAL_ERROR_MESSAGE_IMPORT)
      }
    },
    getMenuStatus() {
      if (this.errorMessageArray.length > 0) {
        this.heightMessageBox = this.getHeightOfMessage(this.errorMessageArray[0])
      }
    }
  }
}
</script>
<style lang="scss" scoped>
$message-animation-time: var(--alert-message-animation-time);

// $colorMessage: メッセージの色
@mixin alert-message($colorMessage) {
  display: flex;
  align-items: center;

  position: absolute;
  top: 0px;
  z-index: 97500;

  width: 100%;
  min-height: $default-message-height;
  line-height: 1.2;
  padding: 5px 10px;

  border: 1px solid $colorMessage;
  background-color: $colorMessage;
  color: #ffffff;
}

.message-main-screen {
  position: relative;
}

.message-modal {
  position: sticky;
  top: 4px;
  z-index: 97500;
  background-color: #ffff;
}

.alert {
  word-wrap: break-word;
  word-break: break-all;
  margin: 0px;
}

.alert-success {
  @include alert-message(#4e66a6);
}

.alert-danger {
  @include alert-message(#b41b3e);
}

.success-msg-container,
.error-msg-container {
  height: 0px;
  position: relative;
  top: 0px;
  font-weight: 400 !important;
  animation: displayed-message-animation $message-animation-time linear;
  animation-fill-mode: forwards;
}

.success-msg-box,
.error-msg-box {
  position: absolute;
  top: 0px;

  width: 100%;
  height: fit-content;
  font-weight: 400 !important;
}

.text-error-message {
  width: fit-content;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  display: -webkit-box;
}

.animated-success-msg-container,
.animated-error-msg-container {
  position: relative;
  top: 0px;
  height: var(--messageHeight);
  animation: hidden-message-animation $message-animation-time linear;
  animation-fill-mode: forwards;
  text-overflow: hidden;
}

.slide-enter-active {
  -moz-transition-duration: $message-animation-time;
  -webkit-transition-duration: $message-animation-time;
  -o-transition-duration: $message-animation-time;
  transition-duration: $message-animation-time;
  -moz-transition-timing-function: linear;
  -webkit-transition-timing-function: linear;
  -o-transition-timing-function: linear;
  transition-timing-function: linear;
}

.slide-leave-active {
  -moz-transition-duration: $message-animation-time;
  -webkit-transition-duration: $message-animation-time;
  -o-transition-duration: $message-animation-time;
  transition-duration: $message-animation-time;
  -moz-transition-timing-function: linear;
  -webkit-transition-timing-function: linear;
  -o-transition-timing-function: linear;
  transition-timing-function: linear;
}

.slide-enter-to,
.slide-leave {
  height: var(--messageHeight);
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  height: 0px;
  overflow: hidden;
}

@keyframes displayed-message-animation {
  to {
    // +1px (border)
    height: var(--messageHeight);
  }
}

@keyframes hidden-message-animation {
  from {
    height: $default-message-height
  }
  to {
    height: 0px;
  }
}

.material-icons {
  @include responsive-fs(25);
  &.check-circle {
    margin-right: 5px;
    margin-left: -8px;
  }
  &.report {
    margin-right: 5px;
    margin-left: -8px;
  }
  &.close-message {
    margin-right: -8px;
  }
}

.btn-detail  {
  display: inline-block;
  font-weight: bold;
  color: #ffffff;
  text-decoration: underline;
  width: 50px;
  text-align: center;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/custom-components/AlertMessageComponent.vue